import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { Paper, Theme } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import React from "react";
import CalendarEventLabel from "../../../../components/Calendar/Week/EventLabel";
import { RenderCalendarEventArgs } from "../../../../components/Calendar/Week/utils";
import { MealMenuInstance } from "../../types";
import { getHueForMealMenu, getMealMenuCalendarLabel, getTextColor } from "../color";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    checkRoot: {
      alignSelf: "flex-start",
      padding: theme.spacing(0.25, 0.5, 0.25, 0.25),
      fontSize: 16,
    },
  })
);

interface MenusCalendarEventDefaultPaperProps {
  mealMenu: MealMenuInstance;
  args: RenderCalendarEventArgs;
  clientTimezone: string;
  bulkEditSelected: boolean;
  onBulkEditChange: (selected: boolean) => void;
  inBulkEdit: boolean;
}

const MenusCalendarEventDefaultPaper = ({
  mealMenu,
  args,
  clientTimezone,
  bulkEditSelected,
  onBulkEditChange,
  inBulkEdit,
}: MenusCalendarEventDefaultPaperProps) => {
  const { PaperProps, isAbbreviated, isContinuation = false, slot } = args;

  const classes = useStyles();

  const hue = getHueForMealMenu(mealMenu.type, slot);
  const backgroundColor = `hsl(${hue}, 85%, 65%)`;
  const textColor = getTextColor(backgroundColor);

  return (
    <Paper
      {...PaperProps}
      style={{
        ...PaperProps.style,
        backgroundColor,
        border: mealMenu.athleteCount === 0 ? "1px solid red" : "",
        display: "flex",
        justifyContent: "flex-start",
        color: textColor,
      }}
      onClick={inBulkEdit ? () => onBulkEditChange(!bulkEditSelected) : PaperProps.onClick}
    >
      {inBulkEdit && bulkEditSelected && <CheckBoxIcon className={classes.checkRoot} style={{ color: textColor }} />}
      <CalendarEventLabel
        primary={getMealMenuCalendarLabel(mealMenu.name, isContinuation)}
        isAbbreviated={isAbbreviated}
        start={mealMenu.start}
        durationInMinutes={mealMenu.durationInMinutes}
        clientTimezone={clientTimezone}
      />
    </Paper>
  );
};

export default MenusCalendarEventDefaultPaper;
